import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';
import Header from '@/components/storefront/Header';
import Footer from '@/components/storefront/Footer';

export default function NotFoundPage() {
  return (
    <div data-testid="not-found-page" className="min-h-screen" style={{ backgroundColor: '#FDFBF7' }}>
      <Helmet><title>Page Not Found - Florashop</title></Helmet>
      <Header />
      <div className="max-w-lg mx-auto px-6 py-24 text-center">
        <p className="font-serif text-8xl font-bold mb-4" style={{ color: 'rgba(0,0,0,0.06)' }}>404</p>
        <h1 className="font-serif text-3xl tracking-tight mb-3" style={{ color: '#000' }}>Page Not Found</h1>
        <p className="font-sans text-sm mb-8" style={{ color: '#666' }}>The page you're looking for doesn't exist or has been moved.</p>
        <div className="flex items-center justify-center gap-4">
          <Link to="/shop" className="font-sans text-sm font-bold uppercase tracking-wider px-8 py-3"
            style={{ backgroundColor: '#000', color: '#fff' }}>Continue Shopping</Link>
          <Link to="/" className="font-sans text-sm underline" style={{ color: '#666' }}>Go Home</Link>
        </div>
      </div>
      <Footer />
    </div>
  );
}
